document.addEventListener("DOMContentLoaded", function () {
  let touchStartY = 0;
  document.addEventListener('touchstart', function(e) {
    touchStartY = e.touches[0].clientY;
  }, { passive: true });

  function isTap(touchendEvent) {
    return Math.abs(touchendEvent.changedTouches[0].clientY - touchStartY) <= 10;
  }

  // Reusser Accordion
  const accordions = [...document.querySelectorAll('.reusser-accordion-block')];

  if (accordions.length) {
    function toggleAccordion(event) {
      if (event.type === 'touchend' && !isTap(event)) return;
      let target = event.target.closest(".question");

      if (target) {
        event.preventDefault();

        const container = target.closest('.reusser-accordion-block');
        const allQuestions = container.querySelectorAll('.question');
        const allAnswers = container.querySelectorAll('.answer');

        allQuestions.forEach(q => {
          if (q !== target) {
            q.classList.remove("toggled");
            q.setAttribute('aria-expanded', 'false');
          }
        });

        allAnswers.forEach(a => {
          if (a !== target.nextElementSibling) {
            a.hidden = true;
          }
        });

        const answer = target.nextElementSibling;
        const isExpanded = target.getAttribute('aria-expanded') === 'true';

        target.classList.toggle("toggled", !isExpanded);
        target.setAttribute('aria-expanded', String(!isExpanded));

        if (answer && answer.classList.contains('answer')) {
          answer.hidden = isExpanded;
        }
      }
    }

    document.addEventListener("click", toggleAccordion);
    document.addEventListener("touchend", toggleAccordion);
  }

  // IAMOTA Accordion
  const iamotaAccordions = document.querySelectorAll('.iamota-accordion');

  if (iamotaAccordions.length) {
    function toggleIamotaAccordion(event) {
      if (event.type === 'touchend' && !isTap(event)) return;
      const button = event.target.closest('.accordion__button');
      if (!button) return;

      event.preventDefault();

      const wrapper = button.closest('.iamota-accordion');
      const contentId = button.getAttribute('aria-controls');
      const content = document.getElementById(contentId);
      const isExpanded = button.getAttribute('aria-expanded') === 'true';

      // Close all others in same group
      const group = wrapper.closest('.iamota-accordion-group') || document;
      const allButtons = group.querySelectorAll('.accordion__button');

      allButtons.forEach(btn => {
        if (btn !== button) {
          btn.setAttribute('aria-expanded', 'false');
          btn.classList.remove('toggled');
          const btnContentId = btn.getAttribute('aria-controls');
          const btnContent = document.getElementById(btnContentId);
          if (btnContent) {
            btnContent.hidden = true;
            btnContent.classList.remove('toggled');
          }
          const btnWrapper = btn.closest('.iamota-accordion');
          if (btnWrapper) btnWrapper.classList.remove('toggled');
        }
      });

      // Toggle current
      button.setAttribute('aria-expanded', String(!isExpanded));
      button.classList.toggle('toggled', !isExpanded);

      if (wrapper) {
        wrapper.classList.toggle('toggled', !isExpanded);
      }

      if (content) {
        content.hidden = isExpanded;
        content.classList.toggle('toggled', !isExpanded);
      }
    }

    document.addEventListener('click', toggleIamotaAccordion);
    document.addEventListener('touchend', toggleIamotaAccordion);
  }

  // Warranty Bar Accordions
  const warrantyBarAccordions = [...document.querySelectorAll('.warranty-bar-accordion')];

  if (warrantyBarAccordions.length) {
    warrantyBarAccordions.forEach(element => {
      let accordion_title = element.querySelector('.accordion__title');

      function toggleWarrantyBarAccordion(event) {
        if (event.type === 'touchend' && !isTap(event)) return;
        let target = event.target.closest(".accordion-title__container");

        if (target) {
          event.preventDefault();

          const wrapper = target.closest('.warranty-bar-accordion');
          const group = wrapper.closest('.warranty-bar-accordion-group') || document;
          const allTitles = group.querySelectorAll('.accordion-title__container');

          allTitles.forEach(title => {
            if (title !== target) {
              title.classList.remove('toggled');
            }
          });

          target.classList.toggle("toggled");
        }
      }

      accordion_title.addEventListener("click", toggleWarrantyBarAccordion);
      accordion_title.addEventListener("touchend", toggleWarrantyBarAccordion);
    });
  }
});
